import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';


import { HealthService } from 'src/app/core/cms/health/health.service';
import { FooterComponent } from '../../../common-components/footer/footer.component';
import { BreadcrumbComponent } from '../../../common-components/breadcrumb/breadcrumb.component';
import { HeaderComponent } from '../../../common-components/header/header.component';

@Component({
    selector: 'app-medical-underwriting',
    templateUrl: './medical-underwriting.component.html',
    styleUrls: ['./medical-underwriting.scss'],
    imports: [HeaderComponent, BreadcrumbComponent, RouterOutlet, FooterComponent]
})
export class MedicalUnderwritingComponent  {

  constructor() {

  }



}
